import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`${new Date().getFullYear()} 开心武汉市科技有限公司`}
      links={[
        {
          key: 'Happy Wuhan',
          title: '开心武汉',
          href: '#',
          blankTarget: true,
        },
        {
          key: 'Project',
          title: '数据湖',
          href: '#',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
